import Application from "../../metamodel/Application";
import * as React from "react";
import {NavLink} from "react-router-dom";

interface HeaderProps {
    metaModel: Application
}

export default class Header extends React.Component<HeaderProps> {
    constructor(props: HeaderProps) {
        super(props);
    }

    public render(): React.ReactNode {
        if (this.props.metaModel.entities.length < 2) {
            return null;
        }
        return <header id="header" className="header header--background">
            <div className="header__inner">
                <div className="wo__container">
                    <div className="header__content">
                        <nav className="header__nav">
                            <ul className="menu">
                                <li>
                                    <NavLink exact={true} to="/">Home</NavLink>
                                </li>
                                {this.props.metaModel.entities.map(e =>
                                    <li key={e.id}>
                                        <NavLink to={`/${e.id}/zoeken/pagina/1`}>{e.name}</NavLink>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    }

}


// WEBPACK FOOTER //
// ./src/homepage/components/header.tsx